import { extends as _extends, objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import classNames from 'classnames';
import React, { useMemo } from 'react';
import { BoxPrivate } from '../../_primitives/box/box.esm.js';

var _excluded = ["__css", "__themeKey", "className", "width", "columns", "minColumnWidth", "gridTemplateColumns"];
var px = function px(n) {
  return typeof n === 'number' ? n + 'px' : n;
};
var widthToColumns = function widthToColumns(width) {
  return Array.isArray(width) ? width.map(widthToColumns) : width ? "repeat(auto-fit, minmax(".concat(px(width), ", 1fr))") : null;
};
var countToColumns = function countToColumns(n, minColumnWidth) {
  return Array.isArray(n) ? n.map(function (i) {
    return countToColumns(i, minColumnWidth);
  }) : n ? typeof n === 'number' ? "repeat(".concat(n, ", minmax(").concat(minColumnWidth, ", 1fr))") : n : null;
};
var GridPrivate = /*#__PURE__*/React.forwardRef(function GridPrivate(props, ref) {
  var __css = props.__css,
    __themeKey = props.__themeKey,
    className = props.className,
    width = props.width,
    columns = props.columns,
    _props$minColumnWidth = props.minColumnWidth,
    minColumnWidth = _props$minColumnWidth === void 0 ? 0 : _props$minColumnWidth,
    gridTemplateColumns = props.gridTemplateColumns,
    rest = _objectWithoutProperties(props, _excluded);
  var baseStyle = useMemo(function () {
    var _gridTemplateColumns = gridTemplateColumns ? gridTemplateColumns : width ? widthToColumns(width) : columns ? countToColumns(columns, minColumnWidth) : undefined;
    return _objectSpread2(_objectSpread2({
      display: 'grid',
      gridTemplateColumns: _gridTemplateColumns
    }, gridTemplateColumns && width ? {
      width: width
    } : {}), __css);
  }, [__css, columns, gridTemplateColumns, width, minColumnWidth]);
  return /*#__PURE__*/React.createElement(BoxPrivate, _extends({
    ref: ref,
    className: classNames({
      'csg-tui-grid': true
    }, className)
  }, rest, {
    __themeKey: __themeKey ? __themeKey : 'grids',
    __css: baseStyle
  }));
});
var Grid = /*#__PURE__*/React.forwardRef(function Grid(props, ref) {
  return /*#__PURE__*/React.createElement(GridPrivate, _extends({
    ref: ref
  }, props));
});

export default Grid;
export { GridPrivate };
//# sourceMappingURL=grid.esm.js.map
